module.exports = __webpack_public_path__ + "static/media/error-icon.7ab66c27.svg";